import { lastDayOfMonth, isFuture, isValid } from 'date-fns';

/**
 * Returns true if the given string represents an expired date.
 *
 * @param monthYearString - A string with the MM/yy format
 */
export default function creditCardExpired(monthYearString: string): boolean {
  const [month, year] = monthYearString.split('/');
  const formattedString = `${month}/01/20${year}`;
  const dateToCompare = new Date(formattedString);
  if (isValid(dateToCompare)) {
    return !isFuture(lastDayOfMonth(dateToCompare));
  }
  return true;
}
